import moment from "moment-timezone";
import config from "../config";

class Utils {
  static istTime(date) {
    return moment.utc(date).tz("Asia/Kolkata").format(config.DateTimeFormat);
  }
}

export default Utils;
